import { useSelector } from "react-redux";
import locationPinIcon from "../../../../../assets/icons/Location pin.svg";

const CylinderCurrentInfo = () => {
  const { cylinder } = useSelector((state) => state.data.data);
  const isFilled = cylinder.currentState.isFilled;
  const isFilledStyle = `${
    isFilled ? "bg-green-3 text-white" : "bg-lg2 text-lb5"
  } px-3 rounded-md`;

  return (
    <div className="cy-history-currentInfo">
      <h4 className="border-lg5 border-b-1 px-2 py-1">
        Cylinder Number:{" "}
        <span className="text-lb5">{cylinder.serialNumber}</span>
      </h4>
      <div className="flex px-2 py-2 justify-between">
        <p>
          Size: <span className="text-lb5">{cylinder.size}kg</span>
        </p>
        <p className="flex items-center gap-1">
          <img src={locationPinIcon} alt="location pin" />
          Current Station:{" "}
          <span className="text-lb5">
            {cylinder.station.name} ({cylinder.station.id})
          </span>
        </p>
        <p className={isFilledStyle}>{isFilled ? "Filled" : "Empty"}</p>
      </div>
    </div>
  );
};

export default CylinderCurrentInfo;
